import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { OptionsList } from 'components/OptionsList';
import { useStore } from 'hooks/useStore';

const Mobile = () => {
  const {
    app: { i18n },
    filter: { extraParams, isExtraParamsDefault },
    options,
  } = useStore();

  const actions = {
    second: {
      onClick: extraParams.resetExtraParams,
      text: i18n.common.reset,
    },
  };

  return (
    <MobileScreen hasBackButton actions={isExtraParamsDefault ? undefined : actions} title={i18n.extraParams.label}>
      <OptionsList
        options={options.getExtraParams()}
        selectedValues={extraParams.params}
        valueProperty="id"
        onChange={extraParams.setParam}
      />
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
